import { setSafe } from "../../../util/storeHelper";
import * as actions from "../actions/sandbox";
export const settingsReducer = {
    reducers: {
        [actions.setInstallerSandbox]: (state, payload) => setSafe(state, ["installerSandbox"], payload),
    },
    defaults: {
        installerSandbox: true,
    },
};
